import { z } from 'zod';

export const ItemCategorySchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  color: z.string(),
  sort_order: z.number().int(),
  is_active: z.boolean(),
  created_at: z.string(),
  updated_at: z.string(),
});

export const CreateItemCategorySchema = z.object({
  name: z.string().min(1, 'Category name is required').max(100),
  color: z.string().regex(/^#[0-9a-fA-F]{6}$/, 'Must be hex color'),
  sort_order: z.number().int().min(0).optional(),
});

export const UpdateItemCategorySchema = z.object({
  name: z.string().min(1).max(100).optional(),
  color: z.string().regex(/^#[0-9a-fA-F]{6}$/).optional(),
  sort_order: z.number().int().min(0).optional(),
  is_active: z.boolean().optional(),
});

export const ReorderItemCategoriesSchema = z.object({
  items: z.array(z.object({
    id: z.string().uuid(),
    sort_order: z.number().int().min(0),
  })),
});

export type ItemCategory = z.infer<typeof ItemCategorySchema>;
export type CreateItemCategory = z.infer<typeof CreateItemCategorySchema>;
export type UpdateItemCategory = z.infer<typeof UpdateItemCategorySchema>;
export type ReorderItemCategories = z.infer<typeof ReorderItemCategoriesSchema>;
